var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderlineTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "108px",
    height: "5px",
    viewBox: "0 0 108 5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Text-/-title",
    transform: "translate(0.000000, -43.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 43.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#00B1EB",
    x: 0,
    y: 0,
    width: 36,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#4B2A2E",
    x: 36,
    y: 0,
    width: 36,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    fill: "#E40427",
    x: 72,
    y: 0,
    width: 36,
    height: 5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderlineTitle);
export default __webpack_public_path__ + "static/media/underline_title.5d0c59c03ee80fba7fa3a5854a4ba402.svg";
export { ForwardRef as ReactComponent };